import React from 'react'

import { AddCircle, ClipboardTick, User } from 'iconsax-react'
import CustomerProvider from '../../../providers/CustomerProvider'
import EditProvider from '../../../providers/EditProvider'
import MetaProvider from '../../../providers/MetaProvider'

import AddCustomerModal from '../../molecules/ChatModals/AddCustomerModal'
import TaskModal from '../../molecules/ChatModals/TaskModal'

import useAccess, { PERMS } from '../../../hooks/useAccess'
import useStyles from './styles'

const MobileFooter = () => {
  const hasPermission = useAccess()

  const classes = useStyles()

  const [showTaskModal, setShowTaskModal] = React.useState(false)
  const [showCustomerModal, setShowCustomerModal] = React.useState(false)

  const canCreateContact = React.useMemo(
    () => hasPermission([PERMS.ContactsOwn, PERMS.ContactsFull]),
    [hasPermission]
  )

  const canCreateTask = React.useMemo(
    () => hasPermission([PERMS.TasksOwn, PERMS.TasksFull]),
    [hasPermission]
  )

  const showFooter = React.useMemo(
    () => canCreateContact || canCreateTask,
    [canCreateContact, canCreateTask]
  )

  if (!showFooter) {
    return null
  }

  return (
    <div className={classes.root}>
      {canCreateContact && (
        <MetaProvider>
          <EditProvider>
            <CustomerProvider>
              <div
                className={classes.quickAdd}
                data-testid='quick-add-contact'
                onClick={() => {
                  setShowTaskModal(false)
                  setShowCustomerModal(!showCustomerModal)
                }}
              >
                <User className={classes.icon} />

                <AddCircle className={classes.add} />
              </div>

              {showCustomerModal && (
                <AddCustomerModal
                  open={showCustomerModal}
                  onClose={() => setShowCustomerModal(false)}
                  hideInternal={true}
                />
              )}
            </CustomerProvider>
          </EditProvider>
        </MetaProvider>
      )}

      {canCreateTask && (
        <>
          <div
            className={classes.quickAdd}
            data-testid='quick-add-task'
            onClick={() => {
              setShowCustomerModal(false)
              setShowTaskModal(!showTaskModal)
            }}
          >
            <ClipboardTick className={classes.icon} />

            <AddCircle className={classes.add} />
          </div>

          {showTaskModal && (
            <TaskModal
              open={showTaskModal}
              onClose={() => setShowTaskModal(false)}
              canEdit
              canUpdate
            />
          )}
        </>
      )}
    </div>
  )
}

export default MobileFooter
